/**
 * AppSync Events channel for realtime "something changed" pings on a case or
 * client detail page (task created/updated, case patched). Payloads carry no
 * entity data — subscribers refetch through the API, which applies access
 * scope — so any authenticated user may subscribe.
 */
const CONTEXTS_EVENT_NAMESPACE = "contexts";

export const contextEventChannel = (contextType: "case" | "client", contextId: string): string =>
  `${CONTEXTS_EVENT_NAMESPACE}/${contextType}/${contextId}`;

/**
 * Scope of a ping: `task_changed` covers the context's task list,
 * `entity_changed` the parent case/client record, `documents_changed` the
 * context's document list. Subscribers refetch only what the kind names, so a
 * publisher that writes several must send each.
 */
export type ContextEvent =
  | { kind: "task_changed" }
  | { kind: "entity_changed" }
  | { kind: "documents_changed" };

export const isContextEvent = (payload: unknown): payload is ContextEvent => {
  if (typeof payload !== "object" || payload === null || !("kind" in payload)) return false;
  const { kind } = payload;

  return kind === "task_changed" || kind === "entity_changed" || kind === "documents_changed";
};
